import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";

const holdOrders = async (trip_id, reason, component) => {
  const Authorization = "bearer " + localStorage.getItem("token");
  const orderIds = localStorage.getItem("ordersArr");
  const resp = await fetch(`${API_URL}rest/V1/rider/holdOrder`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      jobOrderIds: [trip_id],
      reason: reason,
    }),
  })
    .then(function (response) {
      console.log("gggggg1", response);
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      //   window.location.reload();
      return response.json();
    })
    .then(function (data) {
      console.log("gggggg2", data);
      console.log("checkholddata", data);
      return data;
      // api.callShippingJobs(component,trip_id);
    });

  return resp;
};

export default holdOrders;



// WEBPACK FOOTER //
// ./src/utility/api/holdOrders.js